import { lazy } from "react"
import { useLocation } from "react-router"
import { ErrorBoundary } from "react-error-boundary"

import UnexpectedError from "./unexpected-error"
import { useNavigate } from "react-router-dom"

const NotFound = lazy(() => import("./404"))

const ErrorBoundaary: React.FC = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <ErrorBoundary
      resetKeys={[location.key]}
      fallbackRender={({ error, resetErrorBoundary }) => {
        if (error.name === "404") return <NotFound />
        if ((error as any).response.status === 403) {
          navigate("/permission-error")
        }
        return <UnexpectedError reset={resetErrorBoundary} />
      }}
      children={children}
    />
  )
}

export default ErrorBoundaary
